import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../constants/reservation/SearchContext';
import { getIsFetching } from '../../../redux/Reservation/selectors/upcoming-events';
import { getPaginationQueryOptions } from '../../../redux/Reservation/selectors/upcoming-events/pagination';
import { getSearchQueryForContext } from '../../../redux/Reservation/selectors/components/search';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Reservation/actions/components/search';
import { clearReservationUpcomingEvents } from '../../../redux/Reservation/actions/upcoming-events';
import { fetchReservationUpcomingEvents } from '../../../redux/Reservation/sagas/routines';
import EventSearch from '../../../components/reservations/EventSearch';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(
    state,
    SEARCH_CONTEXT.UPCOMING_EVENTS
  );
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    isFetching: getIsFetching(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {},
    onSubmit: queryOptions => {
      dispatch(clearReservationUpcomingEvents());
      dispatch(fetchReservationUpcomingEvents(queryOptions));
    },
    onChange: query => {
      dispatch(
        onChangeQuery({ context: SEARCH_CONTEXT.UPCOMING_EVENTS, query })
      );
    },
    onClear: () => {
      dispatch(onClearQuery({ context: SEARCH_CONTEXT.UPCOMING_EVENTS }));
      dispatch(clearReservationUpcomingEvents());
      dispatch(fetchReservationUpcomingEvents({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventSearch);
